import {
	BaseError,
} from './BaseError';

export class GetSpecificationUpdatedOfferError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
